/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Commands_SetNtpAlternativeServer_SetNtpAlternativeServerRequest } from '../models/BigClock_Application_Commands_SetNtpAlternativeServer_SetNtpAlternativeServerRequest';
import type { BigClock_Application_Commands_SetNtpServer_SetNtpServerRequest } from '../models/BigClock_Application_Commands_SetNtpServer_SetNtpServerRequest';
import type { BigClock_Application_Queries_GetNtpSynchronization_GetNtpSynchronizationResponse } from '../models/BigClock_Application_Queries_GetNtpSynchronization_GetNtpSynchronizationResponse';
import type { BigClock_Application_Queries_GetSynchronizationState_GetSynchronizationStateResponse } from '../models/BigClock_Application_Queries_GetSynchronizationState_GetSynchronizationStateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClocksService {
    /**
     * @param controlBlockId
     * @returns BigClock_Application_Queries_GetSynchronizationState_GetSynchronizationStateResponse Success
     * @throws ApiError
     */
    public static getApiClocksSynchronization(
        controlBlockId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetSynchronizationState_GetSynchronizationStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Clocks/{controlBlockId}/synchronization',
            path: {
                'controlBlockId': controlBlockId,
            },
        });
    }
    /**
     * @param controlBlockId
     * @returns BigClock_Application_Queries_GetNtpSynchronization_GetNtpSynchronizationResponse Success
     * @throws ApiError
     */
    public static getApiClocksSynchronizationNtp(
        controlBlockId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetNtpSynchronization_GetNtpSynchronizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Clocks/{controlBlockId}/synchronization/ntp',
            path: {
                'controlBlockId': controlBlockId,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClocksSynchronizationNtp(
        controlBlockId: string,
        requestBody?: BigClock_Application_Commands_SetNtpServer_SetNtpServerRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Clocks/{controlBlockId}/synchronization/ntp',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClocksSynchronizationNtpAlternative(
        controlBlockId: string,
        requestBody?: BigClock_Application_Commands_SetNtpAlternativeServer_SetNtpAlternativeServerRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Clocks/{controlBlockId}/synchronization/ntp/alternative',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClocksSynchronizationNtpState(
        controlBlockId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Clocks/{controlBlockId}/synchronization/ntp/state',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param controlBlockId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiClocksSynchronizationNtpTime(
        controlBlockId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Clocks/{controlBlockId}/synchronization/ntp/time',
            path: {
                'controlBlockId': controlBlockId,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClocksSynchronizationGpsState(
        controlBlockId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Clocks/{controlBlockId}/synchronization/gps/state',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
